<template>
  <div>
    <modal-form modal-id="add-pbn" v-if="user.admin">
      <div slot="title">Add Pbn</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Domain</div>
            <div class="col-lg-8"><textarea name="" v-model="pbn['domain']" class="form-control"></textarea></div>
            <div class="col-lg-4">Client</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['client']" :options="this.filters.clients" label="name" :reduce="c => c.id"></v-select>
            </div>
            <div class="col-lg-4">Group</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['group']" :options="this.filters.groups" label="name" :reduce="c => c.id" index="id"></v-select>
            </div>
            <div class="col-lg-4">Order</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['order']" :options="this.filters.orders" label="name" :reduce="c => c.id" index="id"></v-select>
            </div>
            <div class="col-lg-4">Create staging</div>
            <div class="col-lg-8">
              <input type="checkbox" v-model="pbn['staging']">
            </div>
            <div class="col-lg-4">Build Flow</div>
            <div class="col-lg-8">
              <input type="checkbox" v-model="pbn['buildFlow']">
            </div>
          </div>
          <div class="col-lg-12">
            <button class="btn btn-sm btn-primary" @click="addPbn">Save</button>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox-content table-responsive col-lg-12">
      <button :class="'btn btn-sm m-b-sm ' + (editMode ? 'btn-primary' : 'btn-white')" @click="editMode = !editMode" v-if="user.admin">Edit mode</button>
      <button class="btn btn-sm btn-primary pull-right" data-toggle="modal" data-target="#add-pbn" v-if="user.admin"><i class="fa fa-plus"></i> Add Pbn</button>
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Domain</th>
          <th>Client</th>
          <th>Group</th>
          <th>Theme</th>
          <th>Whois owner</th>
          <th>Whois registrar</th>
          <th>Posts</th>
          <th>Index count</th>
          <th title="Indexed"><i class="fas fa-tasks"></i></th>
          <th title="Home indexed"><i class="fa fa-home"></i></th>
          <th title="Index to posts rate"><i class="fas fa-tasks"></i> / <i class="far fa-file"></i></th>
          <th><i class="fas fa-tasks"></i> 200</th>
          <th><i class="fas fa-tasks"></i> 404</th>
          <th><i class="fas fa-tasks"></i> ?</th>
          <th>Expires</th>
          <th>Links</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="site in sites" :key="site.id">
          <td>
            <pbn :pbn="site"></pbn>
          </td>
          <td :title="site.client ? site.client.name : '?'">{{ site.client ? shorten(site.client.name, 15) : '/'}}</td>
          <td :title="site.group ? site.group.name : '/'">
            <v-select
              v-if="editMode"
              :options="filters.groups"
              label="name"
              index="id"
              :value="site.group"
              @input="updatePbn($event, 'group', site.domain)"
            ></v-select>
            <span v-else>{{ site.group ? shorten(site.group.name, 15) : '/'}}</span>
          </td>
          <td>
            {{ site.wpData.theme || '?' }}
          </td>
          <td>{{ site.whois !== null ? site.whois.owner.length > 0 ? site.whois.owner : '/' : '/' }}</td>
          <td>{{ site.whois !== null ? site.whois.registrar : '/' }}</td>
          <td :title="site.content && site.content.contentCount > 0 ? 'Posts: ' + site.content.posts + ' | Pages: ' + site.content.pages: 0">
            {{ site.content ? site.content.contentCount : '?' }}
          </td>
          <td>
            {{ site.indexCount || '/' }}
          </td>
          <td>
            <i class="fa fa-check green" v-if="site.indexed === true"></i>
            <i class="fa fa-remove red" v-else-if="site.indexed === false"></i>
            <i class="fa fa-question orange" v-else></i>
          </td>
          <td>
            <i class="fa fa-check green" v-if="site.homeIndexed === true"></i>
            <i class="fa fa-remove red" v-else-if="site.homeIndexed === false"></i>
            <i class="fa fa-question orange" v-else></i>
          </td>
          <td>
            <span v-if="site.indexed && site.content.contentCount">
              {{ Number.parseFloat((site.indexCount || 0) / site.content.contentCount || 1).toFixed(2) }}
            </span>
            <span v-else>/</span>
          </td>
          <td class="green">{{ site.indexCounts['200'] || 0 }}</td>
          <td class="red">{{ site.indexCounts['404'] || 0 }}</td>
          <td class="orange">{{ site.indexCounts['unknown'] || 0 }}</td>
          <td>
            <i class="fa fa-warning" v-if="site.expiresIn < 1 && site.expiresIn > -90" style="color: red;" title="Expired!"></i>
            <span
              :class="!site.expiresIn || site.expiresIn > 30 ? 'green' : (site.expiresIn > 7 ? 'orange' : 'red')"
              :title="site.expires ? $moment(site.expires.date).format('DD.MM.YYYY') : '?'"
              v-if="site.expiresIn > -90"
            >
              {{ site.expiresIn || '?' }}
            </span>
            <span v-else style="color: orange;">?</span>
          </td>
          <td>
            <div v-if="site.linkProfile" v-for="tag in site.linkProfile" :key="tag" class="label label-primary m-r-xs" :title="tag">{{ shorten(tag, 5) }}</div>
          </td>
        </tr>
        </tbody>

        <tfoot>
        <tr>
          <th>Domain</th>
          <th>Client</th>
          <th>Group</th>
          <th>Posts</th>
          <th>Index count</th>
          <th title="Indexed"><i class="fas fa-tasks"></i></th>
          <th title="Home indexed"><i class="fa fa-home"></i></th>
          <th title="Index per post rate"><i class="fas fa-tasks"></i> / <i class="far fa-file"></i></th>
          <th><i class="fas fa-tasks"></i> 200</th>
          <th><i class="fas fa-tasks"></i> 404</th>
          <th><i class="fas fa-tasks"></i> ?</th>
          <th>Expires</th>
          <th>Links</th>
        </tr>
        </tfoot>
      </table>
    </div>
    <div v-if="sitesLoaded">
      <button class="btn btn-primary btn-sm pull-right" @click="searchSites(false)">Load more</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Values } from '../../../../mixins/helperMixin'
import axios from 'axios'
import ModalForm from '../../../Helpers/Modal/Form'
import PbnListItem from '../PbnListItem'

export default {
  data () {
    return {
      sitesLoaded: false,
      editMode: false,
      tagsFor: {},
      pbn: {}
    }
  },
  mixins: [Values],
  components: {
    modalForm: ModalForm,
    pbn: PbnListItem
  },
  computed: {
    ...mapGetters({
      sites: 'getPbns',
      filters: 'getFilters',
      user: 'getUser'
    })
  },
  methods: {
    updateTags (domain, value) {
      axios.patch('/pbn/site/' + domain, {
        tags: value
      }).then(r => {
        this.$toastr.success('PBN Tags updated', 'Disco Disco')
      }).catch(e => {
        this.$toastr.error(e, 'Tag Update Failed')
      })
    },
    addPbn () {
      if (!this.pbn.domain || this.pbn.domain.length < 5) {
        this.$toastr.error('Please input a domain')
        return
      }
      axios.post('/pbn', {
        domain: this.pbn.domain,
        client: this.pbn.client ? this.pbn.client.id : null,
        staging: !!this.pbn.staging,
        buildFlow: !!this.pbn.buildFlow,
        order: this.pbn.order || null,
        group: this.pbn.group || null
      })
        .then(r => {
          this.$toastr.success('Pbn successfully added', 'Way to go!')
          $('#add-pbn').modal('hide')
          this.pbn = {}
        })
        .catch(e => {
          this.$toastr.error(e, ':(')
        })
    },
    updatePbn (val, opt, domain) {
      let data = {}
      data[opt] = val
      axios.patch('/pbn/site/' + domain, data).then(r => {
        this.$toastr.success('Success!', 'Domain updated successfully')
        // Ideally refresh search? :|
      }).catch(e => {
        this.$toastr.error(e, 'Update failed')
      })
    }
  }
}
</script>
<style>
.green {
  color: green;
}
.orange {
  color: orange;
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/FootprintManager/List.vue